<template>
  <div class="personal-center-modular">
    <div class="user-info-header">
      <img class="header-bg" src="../assets/myOrder/header-bg.png" alt="" />
      <div class="header-absolute-modular">
        <div class="user-info-item">
          <div class="left-item">
            <div class="face-item">
              <img class="user-face" :src="userInfo.face" alt="" />
            </div>
            <div class="info-item">
              <div class="user-name">{{ userInfo.userName }}</div>
              <div class="user-email">{{ userInfo.email }}</div>
              <div class="user-company">{{ userInfo.company }}</div>
            </div>
          </div>
          <div class="right-item">
            <el-button class="edit-btn">编辑</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="personal-center-body">
      <div class="personal-center-body-modualr">
        <el-row :gutter="20">
          <el-col :span="4" :xs="24">
            <div class="menu-modular">
              <div class="menu-header">
                <div class="menu-header-title">个人中心</div>
              </div>
              <div
                class="menu-item"
                v-for="(item, index) in menuList"
                :key="index"
                @click="clickMenu(index)"
              >
                <img
                  class="menu-item-icon"
                  :src="item.flag ? item.icon2 : item.icon1"
                  alt=""
                />
                <span
                  :class="
                    item.flag
                      ? 'menu-item-title-active menu-item-title'
                      : 'menu-item-title'
                  "
                  >{{ item.title }}</span
                >
              </div>
            </div>
          </el-col>
          <el-col :span="20" :xs="24">
            <!-- 我的订单 -->
            <div class="view-modular" v-if="menuActiveIndex == 0">
              <div class="my-order-modualr">
                <el-row :gutter="20">
                  <el-col :span="18" :xs="24">
                    <div class="header-menu">
                      <div
                        :class="
                          orderMenuActive == index
                            ? 'menu-item menu-item-active'
                            : 'menu-item'
                        "
                        v-for="(item, index) in orderMenu"
                        :key="index"
                        @click="orderMenuClick(index)"
                      >
                        <span v-if="item.num == 0" class="menu-item-title">{{
                          item.title
                        }}</span>
                        <el-badge :value="item.num" class="item" v-else>
                          <span class="menu-item-title">{{ item.title }}</span>
                        </el-badge>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="6" :xs="24">
                    <div class="search-header-modualr">
                      <el-input
                        class="search-input"
                        size="medium"
                        placeholder="输入关键词"
                        suffix-icon="el-icon-search"
                        v-model="searchKey"
                      >
                      </el-input>
                    </div>
                  </el-col>
                </el-row>
                <div class="order-info-table-theader">
                  <el-row :gutter="10">
                    <el-col :span="9">
                      <div class="theader-title theader-first-title">
                        产品信息
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">单价</div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">数量</div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">实付款</div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">交易状态</div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">操作</div>
                    </el-col>
                  </el-row>
                </div>
                <div class="order-info-table-tbody">
                  <div
                    class="order-info-item"
                    v-for="(item, index) in orderList"
                    :key="index"
                  >
                    <div class="order-info-item-header">
                      <div class="order-info-item-header-left">
                        <span>{{ item.date }}</span>
                        <span class="order-number"
                          >订单号：{{ item.orderNumber }}</span
                        >
                      </div>
                      <div class="order-info-item-header-right">
                        <img
                          class="delete-icon"
                          src="../assets/myOrder/delete-icon.png"
                          @click="deleteOeder(item.uuid)"
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="order-info-item-body">
                      <el-row :gutter="10">
                        <el-col :span="9" :xs="24">
                          <div class="commodity-info-item">
                            <div class="img-item">
                              <img
                                class="commodity-img"
                                :src="item.commodity.img"
                                alt=""
                              />
                            </div>
                            <div class="detail-item">
                              <div class="commodity-info-item">
                                {{ item.commodity.info }}
                              </div>
                              <div class="commodity-voltage-item">
                                电压：{{ item.commodity.voltage }}
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="8">
                          <div class="commodity-unit-price-item">
                            ${{ item.commodity.unitPrice }}
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="8">
                          <div class="commodity-number-item">
                            {{ item.commodity.number }}
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="8">
                          <div class="commodity-actual-payment-item">
                            {{ item.commodity.actualPayment }}
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="12">
                          <div class="commodity-transaction-state-item">
                            <div class="order-state-item">
                              <div
                                class="order-state-1"
                                v-if="item.commodity.orderState == 1"
                              >
                                待支付
                              </div>
                              <div
                                class="order-state-2"
                                v-else-if="item.commodity.orderState == 2"
                              >
                                待发货
                              </div>
                              <div
                                class="order-state-3"
                                v-else-if="item.commodity.orderState == 3"
                              >
                                待收货
                              </div>
                              <div
                                class="order-state-4"
                                v-else-if="item.commodity.orderState == 4"
                              >
                                交易成功
                              </div>
                            </div>
                            <div class="order-detail-title">订单详情</div>
                            <div
                              class="order-logistics-title"
                              v-show="item.commodity.orderState == 4"
                            >
                              <el-popover
                                placement="left"
                                width="550"
                                trigger="click"
                                v-if="equipmentType == 0"
                              >
                                <div class="order-logistics-popover">
                                  <div class="order-logistics-popover-header">
                                    <div
                                      class="
                                        order-logistics-popover-header-left
                                      "
                                    >
                                      <span class="logisticsName">{{
                                        logisticsData.logisticsName
                                      }}</span>
                                      <span class="courierNumber"
                                        >快递单号：{{
                                          logisticsData.courierNumber
                                        }}</span
                                      >
                                    </div>
                                    <div
                                      class="
                                        order-logistics-popover-header-right
                                      "
                                    >
                                      更多>
                                    </div>
                                  </div>
                                  <div class="order-logistics-popover-body">
                                    <el-timeline>
                                      <el-timeline-item
                                        v-for="(
                                          activity, index
                                        ) in logisticsData.timelineData"
                                        :key="index"
                                        :icon="activity.icon"
                                        :type="activity.type"
                                        :color="activity.color"
                                        :size="activity.size"
                                        :timestamp="activity.timestamp"
                                        placement="top"
                                      >
                                        <h4 v-if="activity.content != null">
                                          {{ activity.content }}
                                        </h4>
                                        <p v-iif="activity.info != null">
                                          {{ activity.info }}
                                        </p>
                                      </el-timeline-item>
                                    </el-timeline>
                                  </div>
                                </div>
                                <el-button
                                  slot="reference"
                                  class="view-order-logistics-btn"
                                  >查看物流</el-button
                                >
                              </el-popover>
                              <el-button
                                v-else
                                class="view-order-logistics-btn"
                                @click="showlogistics()"
                                >查看物流</el-button
                              >
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="12">
                          <div class="operation-item">
                            <div
                              v-if="item.commodity.paymentStatus == 1"
                              class="commodity-paymentStatus-1"
                            >
                              <el-button
                                class="payment-btn"
                                @click="toPayment()"
                                >付款</el-button
                              >
                              <div class="cancel-order-title">取消订单</div>
                            </div>
                            <div
                              v-else-if="item.commodity.paymentStatus == 2"
                              class="commodity-paymentStatus-2"
                            >
                              <div class="cancel-order-title">取消订单</div>
                            </div>
                            <div
                              v-else-if="item.commodity.paymentStatus == 3"
                              class="commodity-paymentStatus-3"
                            >
                              <el-button class="confirm-receipt-btn"
                                >确认收货</el-button
                              >
                            </div>
                            <div
                              v-else-if="item.commodity.paymentStatus == 4"
                              class="commodity-paymentStatus-4"
                            >
                              <el-button class="evaluate-btn">评价</el-button>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
                <div class="pagination-footer-modualr">
                  <el-pagination
                    :pager-count="11"
                    background
                    layout="prev, pager, next"
                    :total="1000"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>

            <!-- 我的评价 -->
            <div v-else-if="menuActiveIndex == 1" class="my-evaluate-modualr">
              <div class="my-evaluate-header-modualr">
                <div
                  :class="
                    index == evaluateHeaderBar.activeBar
                      ? 'evaluate-header-item active-evaluate-item'
                      : 'evaluate-header-item'
                  "
                  v-for="(item, index) in evaluateHeaderBar.barList"
                  :key="index"
                  @click="clickEvaluateHeaderBar(index)"
                >
                  {{ item.title }}
                </div>
              </div>
              <div class="my-evaluate-body-modualr">
                <!-- 产品 -->
                <div
                  class="my-evaluate-body-product-modualr"
                  v-if="evaluateHeaderBar.activeBar == 0"
                >
                  <div class="my-evaluate-body-product-theader">
                    <el-row :gutter="20">
                      <el-col :span="12" :xs="24">
                        <div class="my-evaluate-body-product-theader-title">
                          产品
                        </div>
                      </el-col>
                      <el-col :span="12" :xs="24">
                        <div
                          class="my-evaluate-body-product-theader-title"
                          style="border-left: 1px solid #dddddd"
                        >
                          评价详情
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="my-evaluate-body-product-tbody">
                    <div
                      class="my-evaluate-body-product-item"
                      v-for="(item, index) in evaluateData"
                      :key="index"
                    >
                      <el-row :gutter="20">
                        <el-col :span="12" :xs="24">
                          <div class="my-evaluate-body-product-tbody-left">
                            <div class="img-item">
                              <img
                                class="product-img"
                                :src="item.productIfo.face"
                                alt=""
                              />
                            </div>
                            <div class="info-item">
                              <div class="info-title">
                                {{ item.productIfo.info }}
                              </div>
                              <div class="voltage-title">
                                电压：{{ item.productIfo.voltage }}
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="12" :xs="24">
                          <div class="my-evaluate-body-product-tbody-right">
                            <div class="evaluate-stars-modualr-title">
                              <img
                                class="stars-icon"
                                v-for="(item, index) in getsStarScalculation(
                                  item.evaluateList.stars
                                ).starsFlag1"
                                src="../assets/productDetail/stars-icon-1.png"
                                alt=""
                                :key="index"
                              />
                              <img
                                class="stars-icon"
                                v-for="(item, index) in getsStarScalculation(
                                  item.evaluateList.stars
                                ).starsFlag2"
                                src="../assets/productDetail/stars-icon-0.png"
                                alt=""
                                :key="index"
                              />
                              <img
                                class="stars-icon"
                                v-for="(item, index) in getsStarScalculation(
                                  item.evaluateList.stars
                                ).starsFlag0"
                                src="../assets/productDetail/stars-icon-1.png"
                                alt=""
                                :key="index"
                              />
                            </div>
                            <div class="my-evaluate-title">
                              {{ item.evaluateList.content }}
                            </div>
                            <!-- <div class="my-evaluate-img-item" v-if="item.evaluateList.im"> -->
                            <img
                              class="my-evaluate-img"
                              v-if="item.evaluateList.img"
                              :src="item.evaluateList.img"
                            />
                            <!-- </div> -->
                            <div class="my-evaluate-date">
                              {{ item.evaluateList.dateTime }}
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
                <!-- 产品分页 -->
                <div
                  class="pagination-footer-modualr"
                  v-if="evaluateHeaderBar.activeBar == 0"
                >
                  <el-pagination
                    :pager-count="11"
                    background
                    layout="prev, pager, next"
                    :total="1000"
                  >
                  </el-pagination>
                </div>
                <!-- 博客 -->
                <div
                  class="my-evaluate-body-blog-modualr"
                  v-if="evaluateHeaderBar.activeBar == 1"
                >
                  <div
                    class="my-evaluat-blog-item"
                    v-for="(item, index) in blogListData"
                    :key="index"
                  >
                    <div class="my-evaluat-blog-item-time">
                      {{ item.dateTime }}
                    </div>
                    <div class="my-evaluat-blog-item-title">
                      {{ item.title }}
                    </div>
                    <div class="my-evaluat-blog-item-reply">
                      <span>回复博客：</span>
                      <span>{{ item.replyContent }}</span>
                    </div>
                  </div>
                </div>
                <!-- 博客分页 -->
                <div
                  class="pagination-footer-modualr"
                  v-if="evaluateHeaderBar.activeBar == 1"
                >
                  <el-pagination
                    :pager-count="11"
                    background
                    layout="prev, pager, next"
                    :total="1000"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>

            <!-- 我的收藏 -->
            <div v-else-if="menuActiveIndex == 2" class="my-collection-modualr">
              <div class="my-collection-header">
                <el-input
                  placeholder="输入产品名称"
                  class="search-product-input"
                  suffix-icon="el-icon-search"
                  v-model="input1"
                >
                </el-input>
              </div>
              <div class="my-collection-body">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <div
                      class="commodity-show-item-modualr"
                      v-for="item in 10"
                      :key="item"
                    >
                      <div class="commodity-show-item">
                        <div class="commodity-show-item-img">
                          <img
                            class="commodity-show-img"
                            src="../assets/home/commodity-show-img.png"
                            alt=""
                          />
                        </div>
                        <div class="commodity-show-item-msg">
                          <div class="commodity-show-item-price">
                            $20,500.00
                          </div>
                          <div class="commodity-show-item-introduce">
                            高速全自动SMT贴片机SMT-π8(SMT
                            -Pi8)厂家直供PCB组装机械
                          </div>
                          <div class="commodity-show-item-evaluate">
                            <div class="commodity-evaluate">
                              <span class="commodity-evaluate-num">20</span>
                              <span class="commodity-evaluate-title">评价</span>
                            </div>
                            <div class="commodity-coupon">劵</div>
                          </div>
                          <div class="commodity-show-item-operation">
                            <div class="commodity-collection">
                              <img
                                class="collection-icon"
                                src="../assets/home/collection-icon.png"
                                alt=""
                              />
                              <span class="collection-title">收藏</span>
                            </div>
                            <div class="commodity-shop-cart">
                              <img
                                class="shop-cart-icon"
                                src="../assets/home/shop-cart-icon.png"
                                alt=""
                              />
                              <span class="add-cart-title">加入购物车</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>

            <!-- 我的帖子 -->
            <div v-else-if="menuActiveIndex == 5" class="my-post-modualr">
              <div class="my-post-header-modualr">
                <div
                  :class="
                    index == postHeaderBar.activeBar
                      ? 'post-header-item active-post-item'
                      : 'post-header-item'
                  "
                  v-for="(item, index) in postHeaderBar.barList"
                  :key="index"
                  @click="clickPostHeaderBar(index)"
                >
                  {{ item.title }}
                </div>
              </div>
              <div class="my-post-body-modualr">
                <!-- 我的帖子列表 -->
                <div
                  class="my-post-body-modualr"
                  v-if="postHeaderBar.activeBar == 0"
                >
                  <div class="my-post-body-tbody">
                    <div
                      class="my-post-body-item"
                      v-for="(item, index) in postData"
                      :key="index"
                    >
                      <div class="my-post-body-time">{{ item.time }}</div>
                      <div class="my-post-body-title">{{ item.title }}</div>
                      <div class="my-post-body-content">{{ item.content }}</div>
                      <div class="my-post-body-msg-footer">
                        <div class="my-post-tag">{{ item.tag }}</div>
                        <div class="my-post-icon-num">
                          <div class="my-post-disFlex">
                            <img
                              src="../assets/forum/news-icon.png"
                              alt=""
                              class="news-icon"
                            />
                            <div>{{ item.commentNum }}</div>
                          </div>
                          <div class="my-post-disFlex margin30">
                            <img
                              src="../assets/blog/view-icon.png"
                              alt=""
                              class="view-icon"
                            />
                            <div>{{ item.readNum }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 帖子分页 -->
                <div
                  class="pagination-footer-modualr"
                  v-if="postHeaderBar.activeBar == 0"
                >
                  <el-pagination
                    :pager-count="11"
                    background
                    layout="prev, pager, next"
                    :total="1000"
                  >
                  </el-pagination>
                </div>
                <!-- 我回复的 -->
                <div
                  class="my-post-body-modualr"
                  v-if="postHeaderBar.activeBar == 1"
                >
                  <div class="my-post-body-tbody">
                    <div
                      class="my-post-body-item"
                      v-for="(item, index) in postreplyData"
                      :key="index"
                    >
                      <div class="my-post-body-time">{{ item.time }}</div>
                      <div class="my-post-body-title">
                        {{ item.replyContent }}
                      </div>
                      <div class="my-post-body-post">
                        回复帖子：{{ item.post }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 博客分页 -->
                <div
                  class="pagination-footer-modualr"
                  v-if="postHeaderBar.activeBar == 1"
                >
                  <el-pagination
                    :pager-count="11"
                    background
                    layout="prev, pager, next"
                    :total="1000"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>

            <!-- 个人中心 -->
            <div v-else-if="menuActiveIndex == 6" class="my-post-modualr">
              <div class="my-post-header-modualr">
                <div
                  :class="
                    index == userHeaderBar.activeBar
                      ? 'post-header-item active-post-item'
                      : 'post-header-item'
                  "
                  v-for="(item, index) in userHeaderBar.barList"
                  :key="index"
                  @click="clickUserHeaderBar(index)"
                >
                  {{ item.title }}
                </div>
              </div>
              <div
                class="userInfo-body-modualr"
                v-if="userHeaderBar.activeBar == 0"
              >
                <el-form ref="form" :model="userInfoForm" label-width="80px">
                  <div class="userInfo-disFlex magin30">
                    <img :src="userInfoForm.face" alt="" class="face-img" />
                    <span class="edit-face" @click="editFaceDialog"
                      >修改头像</span
                    >
                  </div>
                  <el-form-item label="姓名">
                    <el-input v-model="userInfoForm.userName"></el-input>
                  </el-form-item>
                  <el-form-item label="性别">
                    <el-radio-group
                      v-model="userInfoForm.gender"
                      fill="#EC0000"
                      text-color="#EC0000"
                    >
                      <el-radio label="0">男</el-radio>
                      <el-radio label="1">女</el-radio>
                      <el-radio label="3">保密</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="电话">
                    <div>
                      {{ userInfoForm.phone }}
                      <span class="replaceBtn" @click="replacePhoneDialog"
                        >更换</span
                      >
                    </div>
                  </el-form-item>
                  <el-form-item label="邮箱">
                    <div>
                      {{ userInfoForm.email }}
                      <span class="replaceBtn" @click="replaceEmailDialog"
                        >更换</span
                      >
                    </div>
                  </el-form-item>
                  <el-form-item label="国家">
                    <div class="nation-input">
                      <el-input
                        v-model="userInfoForm.nation"
                        @focus="selectNation"
                      ></el-input>
                      <img
                        class="select-icon nation"
                        src="../assets/public/up-arrow-icon.png"
                        alt=""
                      />
                    </div>
                  </el-form-item>
                  <el-form-item label="生日" class="birthday-form-item">
                    <el-row>
                      <el-col :span="8">
                        <el-date-picker
                          v-model="userInfoForm.year"
                          type="year"
                          placeholder="选择年"
                          format="yyyy"
                        >
                        </el-date-picker>
                        <span class="margin3">年</span>
                      </el-col>
                      <el-col :span="8">
                        <el-date-picker
                          v-model="userInfoForm.month"
                          type="month"
                          placeholder="选择月"
                          format="MM"
                        >
                        </el-date-picker>
                        <span class="margin3">月</span>
                      </el-col>
                      <el-col :span="8">
                        <el-date-picker
                          v-model="userInfoForm.datetime"
                          type="date"
                          placeholder="选择日"
                          format="dd"
                        >
                        </el-date-picker>
                        <span class="margin3">日</span>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item label="公司">
                    <el-input v-model="userInfoForm.company"></el-input>
                  </el-form-item>
                  <div class="userInfo-save">
                    <button class="save-button">保存</button>
                  </div>
                </el-form>
              </div>
              <div
                class="userInfo-body-modualr"
                v-if="userHeaderBar.activeBar == 1"
              >
                <div class="edit-password-content">
                  <el-form
                    label-position="top"
                    label-width="80px"
                    :model="formEditPassword"
                  >
                    <el-form-item label="原密码">
                      <el-input
                        v-model="formEditPassword.oldPassword"
                        placeholder="请输入原密码"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="新密码">
                      <el-input
                        v-model="formEditPassword.newPassword"
                        placeholder="请输入新密码"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码">
                      <el-input
                        v-model="formEditPassword.surePassword"
                        placeholder="请确认新密码"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                  <div class="userInfo-save">
                    <button class="save-button">保存</button>
                  </div>
                </div>
              </div>
              <div
                class="userInfo-body-modualr"
                v-if="userHeaderBar.activeBar == 2"
              >
                <div class="account-bind-content">
                  <div
                    class="account-bind-item"
                    v-for="(item, index) in bindAccountList"
                    :key="index"
                  >
                    <div class="account-bind-disFlex">
                      <img :src="item.icon" alt="" class="bind-icon" />
                      <div class="account-bind-name">{{ item.name }}</div>
                    </div>
                    <div class="account-bind-nickName">
                      {{ item.bindStatus == 0 ? "未绑定" : item.nickName }}
                    </div>
                    <div
                      :class="
                        item.bindStatus == 0
                          ? 'green-text bind-status'
                          : 'red-text'
                      "
                    >
                      {{ item.bindStatus == 0 ? "绑定" : "解绑" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog title="物流信息" :visible.sync="showLogistics" width="95%">
      <div class="order-logistics-popover-header">
        <div class="order-logistics-popover-header-left">
          <span class="logisticsName">{{ logisticsData.logisticsName }}</span>
          <span class="courierNumber"
            >快递单号：{{ logisticsData.courierNumber }}</span
          >
        </div>
        <div class="order-logistics-popover-header-right">更多></div>
      </div>
      <div class="order-logistics-popover-body">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in logisticsData.timelineData"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size"
            :timestamp="activity.timestamp"
            placement="top"
          >
            <h4 v-if="activity.content != null">{{ activity.content }}</h4>
            <p v-iif="activity.info != null">{{ activity.info }}</p>
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showLogistics = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 修改头像 -->
    <el-dialog
      title="修改头像"
      :visible.sync="showeditFace"
      class="upload-face-dialog"
    >
      <div>
        <el-upload>
          <button class="upload-img-btn">上传图片</button>
          <div slot="tip" class="el-upload__tip">
            支持jpg、jpeg、png 格式的图片<br />推荐尺寸：200*200或等比例图片
          </div>
        </el-upload>
        <div class="show-img">
          <img :src="userInfoFace" alt="" />
        </div>
        <div>
          <button class="save-button">保存</button>
        </div>
      </div>
    </el-dialog>

    <!-- 修改手机号码 -->
    <el-dialog
      :title="editoldEmailDialog?'修改邮箱':'修改手机号码'"
      :visible.sync="editoldPhoneDialog"
      class="upload-phone-dialog"
    >
      <!-- 修改手机号码1 -->
      <div v-if="editoldPhone">
        <div class="forget-text">原{{editoldEmailDialog?'邮箱':'手机号码'}}</div>
        <div class="address-text">输入与您的 锦格 账户相关联的{{editoldEmailDialog?'邮箱':'手机号码'}}。</div>
        <div class="phone-input">
          <span class="title">
            <span class="red-color">*</span>
            {{editoldEmailDialog?'邮箱':'电话'}}</span
          >
          <input
            type="text"
            :class="editoldEmailDialog?'account padding20 phone-suffix':'account padding100 phone-suffix'"
            v-model="oldPhone"
          />
          <div class="phone-prefix-modular" v-if="!editoldEmailDialog">
            <input type="text" class="phone-prefix" v-model="phonePrefix" />
            <img
              class="select-icon"
              src="../assets/public/up-arrow-icon.png"
              alt=""
            />
          </div>
        </div>
        <div>
          <button class="login-button" @click="tophoneVerification">
            继续
          </button>
        </div>
      </div>
      <!-- 修改手机号码2 -->
      <div v-if="oldphoneVerification">
        <div class="forget-text">验证信息</div>
        <div class="address-text">
          要继续，请完成此验证步骤。 我们已向{{editoldEmailDialog?'邮箱':'手机号码'}}<br />{{ editoldEmailDialog?'':phonePrefix }}
          {{ oldPhone }}发送了验证码。 请在下面输入。
        </div>
        <div class="phone-input">
          <span class="title">
            <span class="red-color">*</span>
            验证码</span
          >
          <input
            type="text"
            class="account padding20 phone-suffix"
            v-model="verificationcode"
          />
        </div>
        <div>
          <button class="login-button" @click="tonewPhone">继续</button>
        </div>
      </div>
      <!-- 修改手机号码3 -->
      <div v-if="editnewPhone">
        <div class="forget-text">新{{editoldEmailDialog?'邮箱':'手机号码'}}</div>
        <div class="address-text">
          输入要关联的新{{editoldEmailDialog?'邮箱':'手机号码'}}。我们将向该号码发送验证代码。
        </div>
        <div class="phone-input">
          <span class="title">
            <span class="red-color">*</span>
            {{editoldEmailDialog?'邮箱':'电话'}}</span
          >
          <input
            type="text"
            :class="editoldEmailDialog?'account padding20 phone-suffix':'account padding100 phone-suffix'"
            v-model="oldPhone"
          />
          <div class="phone-prefix-modular" v-if="!editoldEmailDialog">
            <input type="text" class="phone-prefix" v-model="phonePrefix" />
            <img
              class="select-icon"
              src="../assets/public/up-arrow-icon.png"
              alt=""
            />
          </div>
        </div>
        <div>
          <button class="login-button" @click="tonewPhoneVerification">
            继续
          </button>
        </div>
      </div>
      <!-- 修改手机号码4 -->
      <div v-if="newphoneVerification">
        <div class="forget-text">验证信息</div>
        <div class="address-text">
          要继续，请完成此验证步骤。 我们已向{{editoldEmailDialog?'邮箱':'手机号码'}}<br />{{ editoldEmailDialog?'':phonePrefix }}
          {{ oldPhone }}发送了验证码。 请在下面输入。
        </div>
        <div class="phone-input">
          <span class="title">
            <span class="red-color">*</span>
            验证码</span
          >
          <input
            type="text"
            class="account padding20 phone-suffix"
            v-model="verificationcode"
          />
        </div>
        <div>
          <button class="login-button" @click="tonewPhoneSure">确定</button>
        </div>
      </div>
    </el-dialog>
    <!-- 选择国家 -->
    <el-dialog
      title="选择国家"
      :visible.sync="selectNationDialog"
      width="50%"
      class="select-nation-dialog"
    >
      <div class="select-nation-content">
        <div class="select-nation-title">
          <div
            @click="selectNationTitle(0)"
            :class="nationTitle == 0 ? 'active-title' : ''"
          >
            热门国家
          </div>
          <div
            @click="selectNationTitle(1)"
            :class="nationTitle == 1 ? 'active-title margin40' : 'margin40'"
          >
            ABCDEF
          </div>
          <div
            @click="selectNationTitle(2)"
            :class="nationTitle == 2 ? 'active-title margin40' : 'margin40'"
          >
            GHIJ
          </div>
          <div
            @click="selectNationTitle(3)"
            :class="nationTitle == 3 ? 'active-title margin40' : 'margin40'"
          >
            KLMN
          </div>
          <div
            @click="selectNationTitle(4)"
            :class="nationTitle == 4 ? 'active-title margin40' : 'margin40'"
          >
            PQRSTUV
          </div>
          <div
            @click="selectNationTitle(5)"
            :class="nationTitle == 5 ? 'active-title margin40' : 'margin40'"
          >
            WXYZ
          </div>
        </div>
        <div class="select-nation-name-content">
          <div class="select-nation-name" v-if="nationTitle == 1">
            <div>阿尔巴尼亚</div>
            <div>阿尔巴尼亚</div>
            <div>阿富汗</div>
            <div>爱尔兰</div>
            <div>埃及</div>
            <div>阿曼</div>
            <div>安哥拉</div>
            <div>巴基斯坦</div>
            <div>阿尔巴尼亚</div>
            <div>阿尔巴尼亚</div>
            <div>阿富汗</div>
            <div>爱尔兰</div>
            <div>埃及</div>
            <div>阿曼</div>
            <div>安哥拉</div>
            <div>巴基斯坦</div>
            <div>阿尔巴尼亚</div>
            <div>阿尔巴尼亚</div>
            <div>阿富汗</div>
            <div>爱尔兰</div>
            <div>埃及</div>
            <div>阿曼</div>
            <div>安哥拉</div>
            <div>巴基斯坦</div>
            <div>阿尔巴尼亚</div>
            <div>阿尔巴尼亚</div>
          </div>
        </div>
      </div>
      <div>
        <button class="login-button" @click="tonationSure">保存</button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo: {
        userName: "本杰明",
        face: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202106%2F13%2F20210613235426_7a793.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1677552376&t=db5c65c7d87a436cb5d3f14f9f2a6469",
        email: "jinxiahce@foxmail.com",
        company: "江苏爱察信息技术有限公司",
      },
      // menu-index 控制显示
      menuActiveIndex: 1,
      menuList: [
        {
          index: 0,
          title: "我的订单",
          flag: true,
          icon1: require("../assets/myOrder/order-icon-1.png"),
          icon2: require("../assets/myOrder/order-icon-2.png"),
        },
        {
          index: 1,
          title: "我的评论",
          flag: false,
          icon1: require("../assets/myOrder/comment-icon-1.png"),
          icon2: require("../assets/myOrder/comment-icon-2.png"),
        },
        {
          index: 2,
          title: "我的收藏",
          flag: false,
          icon1: require("../assets/myOrder/collection-icon-1.png"),
          icon2: require("../assets/myOrder/collection-icon-2.png"),
        },
        {
          index: 3,
          title: "优惠券",
          flag: false,
          icon1: require("../assets/myOrder/coupon-icon-1.png"),
          icon2: require("../assets/myOrder/coupon-icon-2.png"),
        },
        {
          index: 4,
          title: "收货地址",
          flag: false,
          icon1: require("../assets/myOrder/address-icon-1.png"),
          icon2: require("../assets/myOrder/address-icon-2.png"),
        },
        {
          index: 5,
          title: "我的贴子",
          flag: false,
          icon1: require("../assets/myOrder/post-icon-1.png"),
          icon2: require("../assets/myOrder/post-icon-2.png"),
        },
        {
          index: 6,
          title: "个人信息",
          flag: false,
          icon1: require("../assets/myOrder/user-info-icon-1.png"),
          icon2: require("../assets/myOrder/user-info-icon-2.png"),
        },
      ],
      orderMenuActive: 0,
      orderMenu: [
        {
          index: 0,
          title: "全部订单",
          num: 0,
        },
        {
          index: 1,
          title: "待支付",
          num: 1,
        },
        {
          index: 2,
          title: "待发货",
          num: 1,
        },
        {
          index: 3,
          title: "待评价",
          num: 1,
        },
        {
          index: 4,
          title: "已完成",
          num: 0,
        },
      ],
      orderList: [
        {
          date: "2022-12-16 16:23:35",
          orderNumber: "25700054169",
          commodity: {
            img: require("../assets/home/commodity-show-img.png"),
            info: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
            voltage: "AC220V",
            unitPrice: "21,000.00",
            actualPayment: "20,500.00",
            number: 1,
            orderState: 1, //订单状态
            paymentStatus: 1, //支付状态
          },
        },
        {
          date: "2022-12-16 16:23:35",
          orderNumber: "25700054169",
          commodity: {
            img: require("../assets/home/commodity-show-img.png"),
            info: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
            voltage: "AC220V",
            unitPrice: "21,000.00",
            actualPayment: "20,500.00",
            number: 1,
            orderState: 2, //订单状态
            paymentStatus: 2, //支付状态
          },
        },
        {
          date: "2022-12-16 16:23:35",
          orderNumber: "25700054169",
          commodity: {
            img: require("../assets/home/commodity-show-img.png"),
            info: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
            voltage: "AC220V",
            unitPrice: "21,000.00",
            actualPayment: "20,500.00",
            number: 1,
            orderState: 3, //订单状态
            paymentStatus: 3, //支付状态
          },
        },
        {
          date: "2022-12-16 16:23:35",
          orderNumber: "25700054169",
          commodity: {
            img: require("../assets/home/commodity-show-img.png"),
            info: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
            voltage: "AC220V",
            unitPrice: "21,000.00",
            actualPayment: "20,500.00",
            number: 1,
            orderState: 4, //订单状态
            paymentStatus: 4, //支付状态
          },
        },
        {
          date: "2022-12-16 16:23:35",
          orderNumber: "25700054169",
          commodity: {
            img: require("../assets/home/commodity-show-img.png"),
            info: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
            voltage: "AC220V",
            unitPrice: "21,000.00",
            actualPayment: "20,500.00",
            number: 1,
            orderState: 4, //订单状态
            paymentStatus: 4, //支付状态
          },
        },
        {
          date: "2022-12-16 16:23:35",
          orderNumber: "25700054169",
          commodity: {
            img: require("../assets/home/commodity-show-img.png"),
            info: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
            voltage: "AC220V",
            unitPrice: "21,000.00",
            actualPayment: "20,500.00",
            number: 1,
            orderState: 4, //订单状态
            paymentStatus: 4, //支付状态
          },
        },
      ],
      // 物流信息
      logisticsData: {
        logisticsName: "邦德快递",
        courierNumber: "db37200006162002",
        timelineData: [
          {
            content: "已签收",
            info: "正常签收，签收人类型：本人，如有疑问请联系：15100001178。",
            timestamp: "2018-04-12 20:46",
            size: "large",
            type: "primary",
            icon: "el-icon-check",
            color: "#EC0000",
          },
          {
            content: "派送中",
            info: "[苏州吴中区车坊镇经营分部]派件员：薛向阳 电话：16626332235 ，派送中，德邦已开启”安全呼叫“，保护您的电话隐私,如有疑问，请联系：0512-51939188",
            timestamp: "2018-04-03 20:46",
          },
          {
            content: "运输中",
            info: "",
            timestamp: "2018-04-03 20:46",
            size: "large",
          },
          {
            content: "",
            info: "[泰安市转运中心公司]已发出",
            timestamp: "2018-04-03 20:46",
          },
          {
            content: "",
            info: "[泰安市转运中心公司]已收入",
            timestamp: "2018-04-03 20:46",
          },
          {
            content: "出库",
            info: "",
            timestamp: "2018-04-03 20:46",
          },
        ],
      },
      showLogistics: false, //显示物信息
      // 手机端，PC端
      equipmentType: 0,
      // 我的评价
      evaluateHeaderBar: {
        activeBar: 0,
        barList: [
          {
            title: "产品",
          },
          {
            title: "博客",
          },
        ],
      },
      // 评价数据
      evaluateData: [
        {
          productIfo: {
            face: require("../assets/home/commodity-show-img.png"),
            info: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
            voltage: "AC220V",
          },
          evaluateList: {
            stars: 5,
            content: "对比多家贴片机后，看中了这款，非常好用！",
            img: require("../assets/home/commodity-show-img.png"),
            dateTime: "2022-11-11  08:08",
          },
        },
        {
          productIfo: {
            face: require("../assets/home/commodity-show-img.png"),
            info: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
            voltage: "AC220V",
          },
          evaluateList: {
            stars: 4,
            content: "对比多家贴片机后，看中了这款，非常好用！",
            img: require("../assets/home/commodity-show-img.png"),
            dateTime: "2022-11-11  08:08",
          },
        },
        {
          productIfo: {
            face: require("../assets/home/commodity-show-img.png"),
            info: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
            voltage: "AC220V",
          },
          evaluateList: {
            stars: 2,
            content: "对比多家贴片机后，看中了这款，非常好用！",
            img: require("../assets/home/commodity-show-img.png"),
            dateTime: "2022-11-11  08:08",
          },
        },
      ],
      // 我的评价 - 博客数据
      blogListData: [
        {
          dateTime: "022-11-11  08:08",
          title: "说的很有道理，学到了",
          replyContent: "如何用普惠t890 拆卸芯片",
        },
        {
          dateTime: "022-11-11  08:08",
          title: "说的很有道理，学到了",
          replyContent: "如何用普惠t890 拆卸芯片",
        },
        {
          dateTime: "022-11-11  08:08",
          title: "说的很有道理，学到了",
          replyContent: "如何用普惠t890 拆卸芯片",
        },
      ],
      // 我的帖子头部
      postHeaderBar: {
        activeBar: 0,
        barList: [
          {
            title: "我的帖子",
          },
          {
            title: "我回复的",
          },
        ],
      },
      postData: [
        {
          time: "2022-11-13  19:15",
          title: "回流温度曲线测试注意事项",
          content: "大家都知道哪些注意事项，一起来聊聊。",
          tag: "讨论",
          commentNum: 2,
          readNum: 100,
        },
        {
          time: "2022-11-13  19:15",
          title: "回流温度曲线测试注意事项",
          content: "大家都知道哪些注意事项，一起来聊聊。",
          tag: "求助",
          commentNum: 2,
          readNum: 100,
        },
        {
          time: "2022-11-13  19:15",
          title: "回流温度曲线测试注意事项",
          content: "大家都知道哪些注意事项，一起来聊聊。",
          tag: "讨论",
          commentNum: 3,
          readNum: 154,
        },
        {
          time: "2022-11-13  19:15",
          title: "回流温度曲线测试注意事项",
          content: "大家都知道哪些注意事项，一起来聊聊。",
          tag: "求助",
          commentNum: 2,
          readNum: 600,
        },
      ],
      postreplyData: [
        {
          time: "2022-11-13  19:15",
          replyContent:
            "拆卸的操作过程一般为：固定PCB板、调整PCB板和灯头的位置、使红外灯的激光对准需要拆卸的芯片、调整红外灯的高度、放置红外灯的温度传感器",
          post: "如何用普惠t890 拆卸芯片",
        },
        {
          time: "2022-11-13  19:15",
          replyContent:
            "拆卸的操作过程一般为：固定PCB板、调整PCB板和灯头的位置、使红外灯的激光对准需要拆卸的芯片、调整红外灯的高度、放置红外灯的温度传感器",
          post: "如何用普惠t890 拆卸芯片",
        },
        {
          time: "2022-11-13  19:15",
          replyContent:
            "拆卸的操作过程一般为：固定PCB板、调整PCB板和灯头的位置、使红外灯的激光对准需要拆卸的芯片、调整红外灯的高度、放置红外灯的温度传感器",
          post: "如何用普惠t890 拆卸芯片",
        },
      ],
      userHeaderBar: {
        activeBar: 0,
        barList: [
          {
            title: "基本信息",
          },
          {
            title: "修改密码",
          },
          {
            title: "账号绑定",
          },
        ],
      },
      userInfoForm: {
        face: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202106%2F13%2F20210613235426_7a793.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1677552376&t=db5c65c7d87a436cb5d3f14f9f2a6469",
        userName: "本杰明",
        gender: "0",
        phone: "13011111222",
        nation: "中国",
        email: "jinxiahce@foxmail.com",
        company: "江苏爱察信息技术有限公司",
        year: "",
        month: "",
        datetime: "",
      },
      showeditFace: false,
      userInfoFace:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202106%2F13%2F20210613235426_7a793.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1677552376&t=db5c65c7d87a436cb5d3f14f9f2a6469",
      editoldPhoneDialog: false, //修改手机的弹窗
      editoldEmailDialog: false, //修改邮箱
      editoldPhone: false, //输入原手机号
      phonePrefix: "+86",
      oldPhone: "",
      oldphoneVerification: false, //输入原手机号验证码
      verificationcode: "",
      editnewPhone: false, //输入新手机号
      newphoneVerification: false, //输入新手机号验证码

      selectNationDialog: false,
      nationTitle: 1,

      formEditPassword: {
        oldPassword: "",
        newPassword: "",
        surePassword: "",
      },
      bindAccountList: [
        {
          icon: require("../assets/login-icon/QQ.png"),
          name: "QQ",
          bindStatus: 1,
          nickName: "昵称阿冬",
        },
        {
          icon: require("../assets/login-icon/weixin.png"),
          name: "微信",
          bindStatus: 1,
          nickName: "昵称阿冬",
        },
        {
          icon: require("../assets/login-icon/google.png"),
          name: "google",
          bindStatus: 0,
          nickName: "",
        },
        {
          icon: require("../assets/login-icon/paypal.png"),
          name: "paypal",
          bindStatus: 0,
          nickName: "",
        },
        {
          icon: require("../assets/login-icon/vk.png"),
          name: "vk",
          bindStatus: 0,
          nickName: "",
        },
      ],
    };
  },
  methods: {
    /**
     * 菜单点击
     * @param {*} index 
     */
    clickMenu(index) {
      let that = this;
      that.menuList.forEach((v, i) => {
        v.flag = false;
      });
      let newData = that.menuList[index];
      newData.flag = true;
      that.$set(that.menuList, index, newData);
      that.menuActiveIndex = index;
    },

    /**
     * 点击订单的菜单
     * @param {*} index 
     */
    orderMenuClick(index) {
      this.orderMenuActive = index;
    },

    /**
     * 我的订单-菜单点击
     * @param {*} index 
     */
    clickEvaluateHeaderBar(index) {
      let that = this;
      that.evaluateHeaderBar.activeBar = index;
    },

    /**
     * 调转等待付款页面
     */
    toPayment() {
      this.$router.push({
        path: "/waitingPayment",
        query: { page_status:1}
      });
    },

    /**
     * 判断是手机还是PC 1-手机，0-PC
     */
    getEquipmentType() {
      let that = this;
      that.equipmentType = localStorage.getItem("equipmentType");
    },

    /**
     * 查看物流信息
     */
    showlogistics() {
      let that = this;
      that.showLogistics = true;
    },

    /**
     * 星星数量
     * @param {*} startNum 
     */
    getsStarScalculation(startNum) {
      // console.log('startNum',startNum);
      let num = {
        starsFlag0: 0,
        starsFlag1: 0,
        starsFlag2: 0,
      };
      let that = this;
      // 向下取证获取完成的星星数量
      num.starsFlag1 = Math.floor(startNum);
      // 获取半个星星的数量
      num.starsFlag0 = Math.ceil(startNum - Math.floor(startNum));
      // 5减去向上取整获取空的星星数量
      num.starsFlag2 = 5 - Math.ceil(startNum);
      return num;
    },

    /**
     * 我的帖子-菜单点击
     * @param {*} index 
     */
    clickPostHeaderBar(index) {
      this.postHeaderBar.activeBar = index;
    },

    /**
     * 个人中心-菜单点击
     * @param {*} index 
     */
    clickUserHeaderBar(index) {
      this.userHeaderBar.activeBar = index;
    },

    /**
     * 修改头像弹窗
     */
    editFaceDialog() {
      this.showeditFace = true;
    },

    /**
     * 更换手机号
     */
    replacePhoneDialog() {
      this.editoldPhoneDialog = true;
      this.editoldEmailDialog = false;
      this.editoldPhone = true;
      this.oldPhone = "";
    },

    /**
     * 原手机验证
     */
    tophoneVerification() {
      if (this.oldPhone) {
        // this.editoldPhone = false;
        this.editoldPhone = false;
        this.oldphoneVerification = true;
      } else {
        this.$message({
          type: "warning",
          message: "请填写原手机号！",
        });
      }
    },
    tonewPhone() {
      this.oldphoneVerification = false;
      this.editnewPhone = true;
      this.oldPhone = "";
    },
    tonewPhoneVerification() {
      this.editnewPhone = false;
      this.newphoneVerification = true;
      this.verificationcode = "";
    },
    tonewPhoneSure() {
      this.newphoneVerification = false;
      this.editoldPhoneDialog = false;
      this.verificationcode = "";

      this.editoldEmailDialog = false;

    },

    /**
     * 更换邮箱
     */
    replaceEmailDialog() {
      this.editoldPhoneDialog = true;
      this.editoldEmailDialog = true;
      this.editoldPhone = true;
      this.oldPhone = "";
    },
    selectNation() {
      this.selectNationDialog = true;
    },
    tonationSure() {
      this.selectNationDialog = false;
    },
    selectNationTitle(index) {
      this.nationTitle = index;
    },
  },
  mounted() {
    let that = this;
    // 判断是手机还是PC 1-手机，0-PC
    that.getEquipmentType();
  },
};
</script>


// WEBPACK FOOTER //
// src/view/personalCenterManagement-2.vue